import { NgModule } from '@angular/core';
import { LeavePageEffects } from '@app/core/leave-page-handler/effects/leave-page.effects';
import { LeavePageGuard } from '@app/core/leave-page-handler/guards/leave-page.guard';
import { LayoutEffects } from '@app/pcs/actions/layout-effects';
import { AdvancedSearchEffects } from '@app/pcs/effects/advanced-search.effects';
import { AgencyDisplaySettingsEffects } from '@app/pcs/effects/agency-display-settings-effects.service';
import { BulkExportEffects } from '@app/pcs/effects/bulk-export.effects';
import { CalendarEffects } from '@app/pcs/effects/calendar.effects';
import { CalendarEditEffects } from '@app/pcs/effects/calendar-edit.effects';
import { CountryEffects } from '@app/pcs/effects/country.effects';
import { ExportDossierSearchResultsEffects } from '@app/pcs/effects/export-dossier-search-results.effects';
import { FilterEffects } from '@app/pcs/effects/filter.effects';
import { GridLabelEffects } from '@app/pcs/effects/grid-label.effects';
import { InitGridEffects } from '@app/pcs/effects/init-grid.effects';
import { LabelEffects } from '@app/pcs/effects/label.effects';
import { LabelEditEffects } from '@app/pcs/effects/label-edit.effects';
import { LanguageEffects } from '@app/pcs/effects/language-effects';
import { MarkReadStatusEffects } from '@app/pcs/effects/mark-read-status-effects';
import { PcsNgRxFormsEffects } from '@app/pcs/effects/pcs-ngrx-forms.effects';
import { PcsRedirectEffects } from '@app/pcs/effects/pcs-redirect-effects';
import { PermanentImAcceptanceSearchEffects } from '@app/pcs/effects/permanent-im-acceptance-search.effects';
import { SearchEffects } from '@app/pcs/effects/search.effects';
import { ShareFilterLabelEffects } from '@app/pcs/effects/share-filter-label.effects';
import { TrafficPeriodSelectionEffects } from '@app/pcs/effects/traffic-period-selection.effects';
import { UserChangePasswordEffects } from '@app/pcs/effects/user-change-password.effects';
import { UserFilterEffects } from '@app/pcs/effects/user-filter.effects';
import { UserGridConfigurationEffects } from '@app/pcs/effects/user-grid-configuration-effects';
import { FooterModule } from '@app/pcs/footer/footer.module';
import { DictionaryGuard } from '@app/pcs/guards/dictionary-guard';
import { UserTypeActivateGuard } from '@app/pcs/guards/user-type-activate-guard';
import { UserTypeGuard } from '@app/pcs/guards/user-type-guard';
import { ValdrConstraintsGuard } from '@app/pcs/guards/valdr-constraints.guard';
import { HeaderModule } from '@app/pcs/header/header.module';
import { LayoutModule } from '@app/pcs/layout/layout.module';
import { PcsRoutingModule } from '@app/pcs/pcs-routing.module';
import { reducers } from '@app/pcs/reducer';
import { reducerForAdvanceSearch } from '@app/pcs/reducer/advanced-search';
import { PcsServicesModule } from '@app/pcs/services/pcs-services.module';
import { NotificationsEffects } from '@app/pcs/shared/notifications/store/effects/notifications-effects';
import { reducerForPcsNotifications } from '@app/pcs/shared/notifications/store/reducer';
import { PcsSharedModule } from '@app/pcs/shared/pcs-shared.module';
import { SharedModule } from '@app/shared/shared.module';
import { WizardNavigationEffects } from '@app/shared/wizard-navigation/effects/wizard-navigation.effects';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

const effects = [
  PcsRedirectEffects,
  PcsNgRxFormsEffects,
  LeavePageEffects,
  WizardNavigationEffects,
  AgencyDisplaySettingsEffects,
  AdvancedSearchEffects,
  SearchEffects,
  LabelEffects,
  LabelEditEffects,
  GridLabelEffects,
  InitGridEffects,
  MarkReadStatusEffects,
  FilterEffects,
  UserFilterEffects,
  UserGridConfigurationEffects,
  UserChangePasswordEffects,
  ShareFilterLabelEffects,
  CalendarEditEffects,
  TrafficPeriodSelectionEffects,
  BulkExportEffects,
  CalendarEffects,
  CountryEffects,
  LanguageEffects,
  ExportDossierSearchResultsEffects,
  NotificationsEffects,
  PermanentImAcceptanceSearchEffects,
  LayoutEffects
];

@NgModule({
  imports: [
    SharedModule,
    PcsRoutingModule,
    PcsServicesModule,
    PcsSharedModule,
    LayoutModule,
    HeaderModule,
    FooterModule,
    StoreModule.forFeature('pcs', reducers),
    StoreModule.forFeature('advancedSearchState', reducerForAdvanceSearch),
    StoreModule.forFeature('pcsNotificationsState', reducerForPcsNotifications),
    EffectsModule.forFeature(effects)
  ],
  declarations: [
    ...PcsRoutingModule.components
  ],
  providers: [
    DictionaryGuard,
    ValdrConstraintsGuard,
    LeavePageGuard,
    UserTypeGuard,
    UserTypeActivateGuard
  ]
})
export class PcsModule {
}
